module.exports = __WEBPACK_EXTERNAL_MODULE_265__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/events/MouseEvent","root":["openfl","events","MouseEvent"],"commonjs":"openfl/events/MouseEvent","commonjs2":"openfl/events/MouseEvent"}
// module id = 265
// module chunks = 0